function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M432.5 0h-395A37.5 37.5 0 000 37.5v395A37.5 37.5 0 0037.5 470h395a37.5 37.5 0 0037.5-37.5v-395A37.5 37.5 0 00432.5 0zM455 432.5a22.5 22.5 0 01-22.5 22.5h-395A22.5 22.5 0 0115 432.5v-395A22.5 22.5 0 0137.5 15h395A22.5 22.5 0 01455 37.5v395z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M178.5 216a37.5 37.5 0 0037.5-37.5v-58A37.5 37.5 0 00178.5 83h-58A37.5 37.5 0 0083 120.5v58a37.5 37.5 0 0037.5 37.5h58zM98 178.5v-58A22.5 22.5 0 01120.5 98h58a22.5 22.5 0 0122.5 22.5v58a22.5 22.5 0 01-22.5 22.5h-58A22.5 22.5 0 0198 178.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M440 301.3V34.8a7.5 7.5 0 00-7.5-7.6H37.6c-1 0-2 .2-2.9.6l-1.5.8a7.5 7.5 0 00-3.2 6.1l.1 30a7.5 7.5 0 1015 0l-.1-20c0-1.4 1.1-2.5 2.5-2.5h375.1c1.4 0 2.5 1.1 2.5 2.5v256.6a7.7 7.7 0 007.3 7.2c3.9 0 7.4-3.2 7.6-7.2zM425 360v65H45l.1-247.5c0-4.1-3.4-7.5-7.5-7.5a7.6 7.6 0 00-7.5 7.5L30 432.4a7.5 7.5 0 007.5 7.6h333.3c62.6 0 62.6 0 63.5-.2a7.5 7.5 0 005.8-7.3v-72.4M440 360a7.7 7.7 0 00-15 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M304.9 387h19a22.5 22.5 0 0022.5-22.5v-12h12a22.5 22.5 0 0022.5-22.5v-19a22.5 22.5 0 00-22.5-22.5h-12v-12a22.5 22.5 0 00-22.5-22.5h-19a22.5 22.5 0 00-22.5 22.5v12h-12a22.5 22.5 0 00-22.5 22.5v19a22.5 22.5 0 0022.5 22.5h12v12a22.5 22.5 0 0022.5 22.5zm-34.5-49.5a7.6 7.6 0 01-7.5-7.5v-19c0-4.1 3.4-7.5 7.5-7.5h19.5c4.1 0 7.5-3.4 7.5-7.5v-19.5c0-4.1 3.4-7.5 7.5-7.5h19c4.1 0 7.5 3.4 7.5 7.5V296c0 4.1 3.4 7.5 7.5 7.5h19.5c4.1 0 7.5 3.4 7.5 7.5v19c0 4.1-3.4 7.5-7.5 7.5h-19.5a7.6 7.6 0 00-7.5 7.5v19.5c0 4.1-3.4 7.5-7.5 7.5h-19a7.6 7.6 0 01-7.5-7.5V345c0-4.1-3.4-7.5-7.5-7.5h-19.5zM149.5 387a66.5 66.5 0 100-133 66.5 66.5 0 000 133zm0-118a51.6 51.6 0 11-.1 103.1 51.6 51.6 0 01.1-103.1zM380.5 168.8l-38.8-67.2c-6.9-12-16.6-18.6-27.3-18.6s-20.3 6.6-27.3 18.6l-38.8 67.2c-6.9 12-7.8 23.7-2.5 32.9s15.9 14.3 29.7 14.3h77.6c13.8 0 24.4-5.1 29.7-14.3s4.6-20.9-2.3-32.9zM370 194.2c-2.5 4.3-8.6 6.8-16.7 6.8h-77.6c-8.1 0-14.2-2.5-16.7-6.8s-1.6-10.9 2.5-17.9l38.8-67.2c4.1-7 9.3-11.1 14.3-11.1s10.2 4 14.3 11.1l38.8 67.2c3.9 7 4.8 13.5 2.3 17.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 37.6,
  cy: 121.3,
  r: 7.5
});

var SvgCategory = function SvgCategory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 470 470",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCategory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/category.019c6c8a.svg";
export { ForwardRef as ReactComponent };